import { isCordova, isIosApp, isIosWeb } from 'utils/platform';

const MAPBOX_ACCESS_TOKEN =
  'pk.eyJ1Ijoid2l0aGxvY2FscyIsImEiOiJVVjdJaUs4In0.uEtnqrpCKRCFc18HcuSBug';

interface MapboxUrlProps {
  latitude: number;
  longitude: number;
  zoom?: number;
  width: number;
  height: number;
}

function getMapboxImageUrl({
  latitude,
  longitude,
  zoom = 14,
  width,
  height,
}: MapboxUrlProps) {
  const marker = `pin-s+d12b79(${longitude},${latitude})`;

  return `https://api.mapbox.com/styles/v1/mapbox/streets-v12/static/${marker}/${longitude},${latitude},${zoom},0/${width}x${height}@2x?before_layer=transit-label&access_token=${MAPBOX_ACCESS_TOKEN}`;
}

function openInExternalMaps(lat: number, lon: number) {
  if (isCordova()) {
    const appMapUrl = isIosApp() ? 'maps:' : `geo:${lat},${lon}`;
    return (window.location.href = `${appMapUrl}?q=${lat},${lon}`);
  }
  const mapUrl = isIosWeb()
    ? 'https://maps.apple.com/'
    : `https://google.com/maps`;
  return window.open(`${mapUrl}?daddr=${lat},${lon}`);
}

export default {
  openInExternalMaps,
  getMapboxImageUrl,
};
